import {
    ADD_ROOM, GET_ROOMS, ROOM_ERROR
} from '../actions/types';

const initialState = {
    room: null,
    rooms: [],
    loading: true,
    error: {}
}


export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case ROOM_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case GET_ROOMS:
            return {
                ...state,
                rooms: payload,
                loading: false,
            };
        case ADD_ROOM:
            return {
                ...state,
                rooms: [payload, ...state.rooms],
                loading: false
            };
        default:
            return state;
    }
}

